export const STANDALONE_STORAGE_KEY = 'cime.standaloneChrome';
export const STANDALONE_QUERY = 'standalone';

export function isStandaloneChrome(
  search: string,
  stored: string | null,
): boolean {
  const raw = search.startsWith('?') ? search.slice(1) : search;
  const sp = new URLSearchParams(raw);
  if (sp.get(STANDALONE_QUERY) === '1') return true;
  return stored === '1';
}

/** Routes ouvrables en onglet sans sidebar de navigation. */
export function canOpenStandalone(pathname: string): boolean {
  return (
    pathname === '/calendrier' ||
    pathname.startsWith('/calendrier/') ||
    pathname === '/dossiers' ||
    pathname.startsWith('/dossiers/')
  );
}

export function withStandaloneParam(pathAndSearch: string): string {
  const url = new URL(pathAndSearch, 'http://cime.invalid');
  url.searchParams.set(STANDALONE_QUERY, '1');
  const q = url.searchParams.toString();
  return `${url.pathname}${q ? `?${q}` : ''}`;
}

export function stripStandaloneParam(search: string): string {
  const raw = search.startsWith('?') ? search.slice(1) : search;
  const sp = new URLSearchParams(raw);
  sp.delete(STANDALONE_QUERY);
  return sp.toString();
}

export function openStandaloneTab(
  pathAndSearch: string,
  openWindow: (url: string, target: string, features: string) => unknown = (url, target, features) =>
    window.open(url, target, features),
): void {
  openWindow(withStandaloneParam(pathAndSearch), '_blank', 'noopener,noreferrer');
}
